// 访客-VISITOR、成员-MEMBER、管理员-ADMIN、超管-SUPER_ADMIN

export const ORG_ROLE = {
  VISITOR: "VISITOR",
  MEMBER: "MEMBER",
  ADMIN: "ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN",
};

const prodConf = {
  gd: 13,
  hb: 57,
};

const BusinessIdConf = {
  dev: {
    gd: 12,
    hb: 33,
  },
  fat: {
    gd: 13,
    hb: 61,
  },
  stage: prodConf,
  prod: prodConf,
} as const;

export const BusinessId = BusinessIdConf[
  process.env.NEXT_PUBLIC_DEPLOY_ENV || "prod"
] as {
  gd: number;
  hb: number;
};

export enum ETypes {
  /** 会员购买 */
  Vip = "Vip",
  /** 权益类购买 */
  Trade = "Trade",
  /** 大会员 */
  PlusVip = "plus",
}

/** 套版权益类型 */
export enum ETradeTypes {
  /** 解决方案 */
  Vip = "SOLUTION",
  /** 增购Vip */
  AdditionVip = "ADDITION_PACKAGE",
  /** 加购席位 */
  Seat = "ADDITION",
  /** 授权书 */
  Certs = "CERTS",
  /** 素材授权书 */
  MaterialCerts = "MATERIAL_CERTS",
  /** 抠图 */
  Matting = "MATTING",
  /** AI点数 */
  AIPoint = "AI_POINT",
  /** 存储空间 */
  Store = "STORAGE_SPACE",
  /** 花瓣会员 */
  HbVip = "HUABAN_SUCAI",
  /** 稿豆 */
  GaoDou = "GAODOU",
  /** 下载次数 */
  Download = "MATERIAL_DOWNLOAD",
}

export enum ESeatTypes {
  /** 套版 */
  Gdesign = "gdesign",
  /** 创作 */
  Creation = "gdcreate",
  /** Insmind */
  Insmind = "gdproductimg",
  /** 花瓣 */
  Huaban = "huaban",
  /** 素材 */
  Material = "gdmaterial",
  /** 大会员 */
  // Plus = 'plus',
}
